import { render } from "./UploadImg.vue?vue&type=template&id=9a3a6804&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"

import "./UploadImg.vue?vue&type=style&index=0&id=9a3a6804&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3a6804"]])

export default __exports__